import { useContext } from "react";

import { CreateProjectFormContext } from "@/pages/projects/forms/create/CreateProjectFormProvider";

export function useCreateProjectFormContext() {
  const context = useContext(CreateProjectFormContext);
  if (!context) {
    throw new Error("useCreateProjectFormContext must be used within a CreateProjectFormProvider");
  }
  return context;
}
